import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLinkedin,
    FaYoutube,
    FaBars,
    FaTimes,
} from "react-icons/fa";
import SearchBox from "./SearchBox";

export default function LogoBar() {
    const [open, setOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const location = useLocation();

    const handleClose = () => setOpen(false);

    // Sticky on scroll
    useEffect(() => {
        const onScroll = () => setIsSticky(window.scrollY > 80);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const MENU = [
        { label: "Home", path: "/" },
        { label: "Trending", path: "/trending" },
        { label: "Breaking", path: "/breaking" },
        { label: "Cricket", path: "/sport/cricket" },
        { label: "Football", path: "/sport/football" },
        { label: "Tennis", path: "/sport/tennis" },
        { label: "Basketball", path: "/sport/basketball" },
        { label: "Hockey", path: "/sport/hockey" },
        { label: "Olympics", path: "/sport/olympics" },
    ];

    return (
        <>
            {/* LOGO BAR */}
            <div
                className={`
                    w-full bg-white border-b border-gray-200 z-50
                    transition-shadow duration-300
                    ${isSticky ? "fixed top-0 shadow-md" : "relative"}
                `}
            >
                {/* MAIN ROW */}
                <div className="max-w-7xl mx-auto px-4 h-20 md:h-24 flex items-center justify-between gap-6">

                    {/* LOGO */}
                    <Link to="/" onClick={handleClose} className="flex items-center h-full shrink-0">
                        <img
                            src="/logo-blogysports.png"
                            alt="BlogySports logo"
                            /* We use scale-150 or higher to make the logo look bigger 
                               while keeping the actual header height small. 
                            */
                            className="h-full w-auto object-contain scale-125 transform origin-left"
                        />
                    </Link>

                    {/* SEARCH (DESKTOP) */}
                    <div className="hidden md:flex flex-1 justify-center max-w-xl">
                        <div className="w-full">
                            <SearchBox />
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="flex items-center gap-4 shrink-0">
                        {/* SOCIAL */}
                        <div className="hidden lg:flex items-center gap-4 text-2xl">
                            <a href="https://www.facebook.com/blogysports" target="_blank" rel="noopener noreferrer">
                                <FaFacebook className="text-[#1877F2] hover:opacity-80 transition-opacity" />
                            </a>
                            <a href="https://twitter.com/blogysports" target="_blank" rel="noopener noreferrer">
                                <FaTwitter className="text-[#1DA1F2] hover:opacity-80 transition-opacity" />
                            </a>
                        </div>

                        {/* MOBILE MENU */}
                        <button
                            className="lg:hidden text-2xl p-2"
                            onClick={() => setOpen(!open)}
                            aria-label="Toggle menu"
                        >
                            {open ? <FaTimes /> : <FaBars />}
                        </button>
                    </div>
                </div>

                {/* MOBILE SEARCH */}
                <div className="md:hidden px-4 pb-3">
                    <SearchBox />
                </div>

                {/* MOBILE MENU */}
                {open && (
                    <div className="lg:hidden bg-white border-t shadow-md">
                        <ul className="flex flex-col divide-y">
                            {MENU.map((item) => (
                                <li key={item.label}>
                                    <Link
                                        to={item.path}
                                        onClick={handleClose}
                                        className={`block px-5 py-4 text-sm font-semibold ${location.pathname.startsWith(item.path)
                                            ? "text-orange-600 bg-orange-50"
                                            : "text-gray-800"
                                            }`}
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {/* SPACER */}
            {isSticky && <div className="h-[84px]" />}
        </>
    );
}
